var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLosIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34,
    height: 26,
    viewBox: "0 0 34 26",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.2255 9.81823C19.9368 9.81823 22.1346 7.62035 22.1346 4.90912C22.1346 2.19789 19.9368 0 17.2255 0C14.5143 0 12.3164 2.19789 12.3164 4.90912C12.3164 7.62035 14.5143 9.81823 17.2255 9.81823Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2255 25.9999C19.9368 25.9999 22.1346 23.802 22.1346 21.0908C22.1346 18.3796 19.9368 16.1817 17.2255 16.1817C14.5143 16.1817 12.3164 18.3796 12.3164 21.0908C12.3164 23.802 14.5143 25.9999 17.2255 25.9999Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.9941 25.9999C31.7053 25.9999 33.9032 23.802 33.9032 21.0908C33.9032 18.3796 31.7053 16.1817 28.9941 16.1817C26.2828 16.1817 24.085 18.3796 24.085 21.0908C24.085 23.802 26.2828 25.9999 28.9941 25.9999Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.45794 25.9999C8.16917 25.9999 10.3671 23.802 10.3671 21.0908C10.3671 18.3796 8.16917 16.1817 5.45794 16.1817C2.74671 16.1817 0.548828 18.3796 0.548828 21.0908C0.548828 23.802 2.74671 25.9999 5.45794 25.9999Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1953 6.95297V18.45",
    stroke: "currentColor"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M5.45801 21.0905V12.8266H29.1975V21.0905",
    stroke: "currentColor",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLosIcon);
export default __webpack_public_path__ + "static/media/LOSIcon.23dcc23e.svg";
export { ForwardRef as ReactComponent };